module.exports = __webpack_public_path__ + "img/2.dff95bb3.png";